module.exports = __webpack_public_path__ + "img/DSC01843.0c1fb01a.jpg";